export enum QuoteExpirationTimeOption {
  ONE_DAY = 'one_day',
  THREE_DAYS = 'three_days',
  SEVEN_DAYS = 'seven_days',
  FOURTEEN_DAYS = 'fourteen_days',
  THIRTY_DAYS = 'thirty_days',
  SIXTY_DAYS = 'sixty_days',
}
